// @core/api/endpoints/team/get_temporary_role_assignment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TemporaryRoleAssignmentResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Get temporary role assignment
 * Retrieves temporary role assignment by the specified identifier.
 */
export async function GetTemporaryRoleAssignment(
  team_id: string,
  assignment_id: string,
  options?: RequestOptions
): Promise<TemporaryRoleAssignmentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/temporary-assignments/:assignment_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':assignment_id', encodeURIComponent(assignment_id));
  const requestOptions = options;
  return client.get<TemporaryRoleAssignmentResponse>(requestPath, { ...requestOptions });
}
